<div class="export-excel-container">
  <div class="export_header">
    <h1 class="text-primary heading">{{ excelExportOptions.HEADING }}</h1>
  </div>
  <div class="d-flex align-items-center gap-2 mt-2 export_body">
    <span class="fs-14 text-dark"> Export as : </span>
    <div class="d-flex flex-row align-items-center">
      <div class="form-check d-flex align-items-center justify-content-center pe-1 cursor-pointer">
        <input class="form-check-input" type="checkbox" [(ngModel)]="isCsv" (change)="isXlsx ? (isXlsx = false) : null" value="" />
      </div>
      <span class="fs-12 text-dark">Csv</span>
    </div>
    <div class="d-flex flex-row align-items-center">
      <div class="form-check d-flex align-items-center justify-content-center pe-1 cursor-pointer">
        <input class="form-check-input" type="checkbox" [(ngModel)]="isXlsx" (change)="isCsv ? (isCsv = false) : null" value="" />
      </div>
      <span class="fs-12 text-dark">Xlsx</span>
    </div>
  </div>
  <div class="fields-container mt-2">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex flex-row align-items-center">
        <div class="form-check d-flex align-items-center justify-content-center pe-1 cursor-pointer">
          <input class="form-check-input" type="checkbox" [(ngModel)]="isAllSelected" (change)="onSelectAll()" value="" id="flexCheckDefault" />
        </div>

        <label class="fs-12 text-truncate cursor-pointer" for="flexCheckDefault"> Select all fields </label>
      </div>
      <p class="fs-12 m-0">Selected Field ({{ getSelectedFieldCount }})</p>
    </div>
    <div class="row mt-3">
      @for (item of excelExportOptions.FIELDS; track item; let idx = $index) {
        <div class="col-6">
          <div class="d-flex flex-row align-items-center">
            <div class="form-check d-flex align-items-center justify-content-center pe-1 cursor-pointer">
              <input class="form-check-input" type="checkbox" [(ngModel)]="item.IsSelected" value="" [id]="item.key" />
            </div>
            <label class="fs-12 text-truncate cursor-pointer" [attr.for]="item.key">
              {{ item.label }}
            </label>
          </div>
        </div>
      }
    </div>
  </div>
  <button class="btn-sm-filled-primary w-100 mt-2" matRipple (click)="onExport()">Export</button>
</div>
